import { useEffect } from 'react';
import { useToast } from '@/hooks/use-toast';
import { useLocation } from 'wouter';

export function useOAuthCallback() {
  const { toast } = useToast();
  const [location, setLocation] = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const oauthSuccess = urlParams.has('oauth_success');
    const platform = urlParams.get('platform');
    const oauthError = urlParams.get('oauth_error');

    if (oauthSuccess) {
      const platformNames: Record<string, string> = {
        facebook: 'Facebook',
        instagram: 'Instagram',
        linkedin: 'LinkedIn',
        googlebusiness: 'Google My Business',
        twitter: 'Twitter/X',
        tiktok: 'TikTok',
        pinterest: 'Pinterest',
        snapchat: 'Snapchat',
      };
      const platformName = platformNames[platform || ''] || platform || 'Social Media';

      toast({
        title: "Verbindung erfolgreich",
        description: `Dein ${platformName} Konto wurde erfolgreich verbunden!`,
        duration: 5000,
      });

      const cleanUrl = window.location.pathname;
      window.history.replaceState({}, '', cleanUrl);
      sessionStorage.removeItem('oauth_platform');
    }

    if (oauthError) {
      const errorCode = urlParams.get('error_code');
      const errorMessage = oauthError;
      
      toast({
        title: "Verbindung fehlgeschlagen",
        description: errorCode 
          ? `${errorMessage} (Code: ${errorCode})`
          : errorMessage,
        variant: "destructive",
        duration: 7000,
      });

      const cleanUrl = window.location.pathname;
      window.history.replaceState({}, '', cleanUrl);
      sessionStorage.removeItem('oauth_platform');
    }
  }, [toast, location]);
}
